import React, { useEffect, useState } from "react";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Link, useNavigate } from "react-router-dom";
import { Select, Spin } from "antd";
import Table from "../../../../core/pagination/datatable.jsx";
import dayjs from "dayjs";
import { Drawer } from "antd";
import { Eye } from "feather-icons-react";
import KpiDetailView from "./KPIDetailView.jsx";
import { ROLL_CALL_API_BASE_URL } from "../../RollCall/RollCallConfig/RollCallConfig.js";

const statusOptions = [
  { label: "All", value: 0 },
  { label: "Submitted", value: 1 },
  { label: "Partially", value: 2 },
  { label: "Pending", value: 3 },
];

const ResponseSummary = () => {
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [loadingTabs, setLoadingTabs] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState(3);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [responseSummary, setResponseSummary] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD"),
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedBranchForView, setSelectedBranchForView] = useState(null);
  const [selectedDateForView, setSelectedDateForView] = useState(null);

  const fetchKpiSummary = async () => {
    if (!tokenData || !superIdData) return;
    const selectedTabObj = tabs?.find((tab) => tab?.id === activeTab);
    const selectedGroupId =
      activeTab === "all" ? 0 : selectedTabObj?.groupId || 0;

    try {
      setSummaryLoading(true);

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKpiResponseSummary?SuperId=${superIdData}&KPIGroupId=${selectedGroupId}&Date=${selectedDate}&Status=${selectedStatus}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (data.status) {
        setResponseSummary(data.ResultData || []);
      } else {
        setResponseSummary([]);
      }
    } catch (error) {
      console.error(error);
      setResponseSummary([]);
    } finally {
      setSummaryLoading(false);
    }
  };

  useEffect(() => {
    fetchKpiSummary();
  }, [selectedStatus, tokenData, selectedDate, activeTab]);

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchKPIGroups = async () => {
    if (!tokenData || !superIdData) return;

    setLoadingTabs(true);
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIGroups?KPIGroupId=0&SuperId=${superIdData}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data, "KPI Groups Response");

      if (data?.status && Array.isArray(data.ResultData)) {
        const formattedTabs = data.ResultData.map((group) => ({
          id: group.Name
            ? group.Name.toLowerCase().replace(/\s+/g, "")
            : `tab-${group.ID}`,
          label: group.Name || "Unnamed Tab",
          icon: getIconForGroup(group.Name),
          groupId: group.ID, // Important: Use ID for fetchKPI
        }));

        setTabs(formattedTabs);

        // Set first tab as active by default
        if (formattedTabs.length > 0 && !activeTab) {
          setActiveTab("all");
        }
      } else {
        setTabs([]);
      }
    } catch (error) {
      console.error("Error fetching KPI Groups:", error);
      setTabs([]);
    } finally {
      setLoadingTabs(false);
    }
  };

  const getIconForGroup = (groupName) => {
    const name = (groupName || "").toLowerCase();
    if (name.includes("daily")) return "fa-chart-line";
    if (name.includes("weekly")) return "fa-calendar-week";
    if (name.includes("monthly")) return "fa-calendar-alt";
    return "fa-chart-bar"; // default
  };

  useEffect(() => {
    fetchKPIGroups();
  }, [tokenData]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Submitted":
        return "success";

      case "Partially":
        return "warning";

      case "Pending":
        return "danger";

      default:
        return "secondary";
    }
  };

  const columns = [
    {
      title: "Branch",
      dataIndex: "BranchName",
      key: "BranchName",
      sorter: (a, b) => a.BranchName.localeCompare(b.BranchName),
      render: (text) => ({
        children: text,
      }),
    },
    {
      title: "Total",
      dataIndex: "TotalMetrics",
      key: "TotalMetrics",
      sorter: (a, b) => a.TotalMetrics - b.TotalMetrics,
      render: (text) => ({
        children: text,
      }),
    },
    {
      title: "Submitted",
      dataIndex: "SubmittedMetrics",
      key: "SubmittedMetrics",
      sorter: (a, b) => a.SubmittedMetrics - b.SubmittedMetrics,
      render: (text) => ({
        // props: {
        //   style: {
        //     backgroundColor: getStatusColor(record.Status),
        //   },
        // },
        children: text,
      }),
    },
    {
      title: "Pending",
      dataIndex: "PendingMetrics",
      key: "PendingMetrics",
      sorter: (a, b) => a.PendingMetrics - b.PendingMetrics,
      render: (text) => ({
        // props: {
        //   style: {
        //     backgroundColor: getStatusColor(record.Status),
        //   },
        // },
        children: text,
      }),
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      sorter: (a, b) => a.Status.localeCompare(b.Status),
      render: (text, record) => {
        const color = getStatusColor(record.Status); // your existing function
        return (
          <span className={`badge bg-${color} badge-sm`}>
            {text || "Unknown"}
          </span>
        );
      },
    },
    {
      title: "Action",
      align: "center",
      render: (text, record) => (
        <button
          className="btn btn-sm btn-light border-0"
          onClick={() => {
            setSelectedBranchForView(record.BranchId);
            setSelectedDateForView(selectedDate);
            setDrawerOpen(true);
          }}
        >
          <Eye size={18} className="text-primary" />
        </button>
      ),
    },
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Response Summary
                    </h4>
                  </ol>
                </nav>
                {/* <h6>Manage your employees</h6> */}
              </div>
            </div>
          </div>

          <div className="card ">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set col-lg-auto col-md-12 mb-md-1 mb-sm-1 mb-lg-0"></div>
              <div className="col-lg-auto col-md-12 mt-md-4 mt-sm-4 mt-lg-0">
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="d-flex flex-wrap gap-3 d-none me-2">
                    <div className="d-flex align-items-center gap-2 ">
                      <span
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "4px",
                          backgroundColor: "#d4edda",
                          display: "inline-block",
                          border: "1px solid #b7dfc3",
                        }}
                      ></span>
                      <span>Submitted</span>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <span
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "4px",
                          backgroundColor: "#fff3cd",
                          display: "inline-block",
                          border: "1px solid #ffe69c",
                        }}
                      ></span>
                      <span>Partially Submitted</span>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <span
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "4px",
                          backgroundColor: "#f8d7da",
                          display: "inline-block",
                          border: "1px solid #f1aeb5",
                        }}
                      ></span>
                      <span>Pending</span>
                    </div>
                  </div>
                  <div className="me-2">
                    <Select
                      placeholder="Select Status"
                      style={{ width: 150, height: 38 }}
                      value={selectedStatus}
                      onChange={handleStatusChange}
                      options={statusOptions}
                    />
                  </div>

                  <div>
                    <input
                      type="date"
                      className="form-control"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-12 mb-3">
                  <div className="card h-100">
                    <div className="card-header bg-light">
                      <h5 className="card-title mb-0">
                        <i className="fa-solid fa-layer-group me-2"></i>
                        KPI Frequency
                      </h5>
                    </div>

                    <div className="card-body p-3">
                      <div
                        className="nav flex-column nav-pills"
                        id="v-pills-tab"
                        role="tablist"
                      >
                        {loadingTabs ? (
                          <div className="text-center py-4">
                            <Spin size="large" />
                            <p className="mt-2">Loading tabs...</p>
                          </div>
                        ) : (
                          <>
                            {tabs?.length > 0 && (
                              <button
                                key="all"
                                className={`nav-link text-start mb-2 ${
                                  activeTab === "all" ? "active" : ""
                                }`}
                                onClick={() => setActiveTab("all")}
                                type="button"
                              >
                                <i className="fa-solid fa-list me-3"></i>
                                All
                              </button>
                            )}
                            {tabs.length > 0 ? (
                              tabs.map((tab) => (
                                <button
                                  key={tab.id}
                                  className={`nav-link text-start mb-2 ${
                                    activeTab === tab.id ? "active" : ""
                                  }`}
                                  onClick={() => setActiveTab(tab.id)}
                                  type="button"
                                >
                                  <i
                                    className={`fa-solid ${tab.icon} me-3`}
                                  ></i>
                                  {tab.label}
                                </button>
                              ))
                            ) : (
                              <p className="text-muted text-center py-4">
                                No tabs available
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-9 col-md-8 col-12">
                  {summaryLoading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <Spin size="large" />
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={responseSummary}
                      rowKey={(record, index) => index}
                      scroll={{ x: true }}
                      bordered
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
        <Drawer
          title={`KPI Details `}
          placement="right"
          width={700}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          destroyOnClose
        >
          <KpiDetailView
            branchId={selectedBranchForView}
            date={selectedDateForView}
            onClose={() => setDrawerOpen(false)}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default ResponseSummary;
